import {Component, Inject, OnInit, Renderer2,ElementRef, PLATFORM_ID, OnDestroy} from '@angular/core';
import {Filters, Product, Wheels} from '../../shared/interfaces/wheels';
import {ApiServices} from '../../shared/services/api.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {DataService} from '../../shared/services/data.service';
import {HelperService} from '../../shared/services/helper.service';
import {ToastrService} from 'ngx-toastr';
import {MetaService} from '../../shared/services/meta.service';

import {FormGroup, Validators} from '@angular/forms';
import {FormService} from '../../shared/services/form.service';

import {Inventory} from '../../shared/interfaces/ProductDetailResponse';
import {NgbModal, ModalDismissReasons, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { MyProfile } from 'src/app/shared/interfaces/MyAccount.interface';


@Component({
  selector: 'app-alloy-wheels',
  templateUrl: './alloy-wheels.component.html',
  styleUrls: ['./alloy-wheels.component.scss']
})
export class AlloyWheelsComponent implements OnInit, OnDestroy {

  queryParams: Params;
  loadProducts = false;
  searchVehicleSub: Subscription;
  loadMoreProducts = false;
  hasNextPage = false;
  filters: Filters;
  products = [];
  brand: any = '';
  showFilters = false;
  currentRoute = '/wheels';
  profileData: MyProfile;
  isDownloding:boolean = false;
  productAddedToCart = null;
  successMessage: string = '';
  warehouse_quantity:any = {};
  clickedProductID:number = null;

  isCustomClassNeeded: boolean = true;

  productCartTotalQty:number[] = [];
  prodQty:number[]=[];
  inventory: Inventory[];
  inventoryData:any = []
  is_hide_cost:any;

  private cartItems: any[] = [];
  private cartProcessing = false;
  cartSubscription: Subscription;
  profSub: Subscription;
  cartResp:any = null;
  prodAddons = [];
  cartaddons:any;
  cartId:any;
  productId:any;
  closeResult: string;
  totalPrice: number;

  listPshow = true;
  rearField = false;
  offsetDropdownValues = [];
  isProductCustomization = false;
  custom_finish = '';
  custom_finish_price;
  bolt_pattern = 'recommended';
  offset = 'recommended';
  pc_cost_per_wheel;
  vehicle_year_make_model = '';
  p_customization_submitted = false;
  addToCartPopup: NgbModalRef;

  searchByVehicle:boolean = false;

  isLoading = false;

  showFirstIcon = true;

  bodyImage = null

  diameter: number;
  activeDiameter = null;
  show_center_bore:boolean = false;
  show_wheel_weight:boolean = false;
  per_page:any = null;
  constructor(
    private apiService: ApiServices,
    private formService: FormService,
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    public helperService: HelperService,
    private metaService: MetaService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private _renderer2: Renderer2,
    private elRef: ElementRef
  ) {
    this.currentRoute = 'wheels';
    if(window.location.pathname == '/wheels') { this.currentRoute = '/wheels'; }
    else if(window.location.pathname == '/pre-order-deals') { this.currentRoute = '/pre-order-deals'; }
    else { this.currentRoute = '/wheelbrand'; }
    this.is_hide_cost = localStorage.getItem("is_hide_cost")

    helperService.setPageTitle(route.snapshot.data.title);
    this.subscribes();
  }

  resolveProfilePage(): void {
    this.profSub = this.dataService.myAccountData.asObservable().subscribe(
      myAccountData => {
        if(myAccountData) {
          this.profileData = myAccountData.my_profile;
        } else {
          this.helperService.getMyAccountData();
        }
      }
    );
  }

  subscribes(): void {
    this.route.params.subscribe(param => this.brand = param.brand);
    // this.getAll();

    // console.log(this.brand);
    // this.dataService.fitmentData.next(false);
    // this.dataService.searchSelections.next(null);
    this.route.queryParams.subscribe(params => {
      if (params) {
        this.queryParams = params;
        // console.log(params.page);
        if(!(params.page >= 2)){
          this.products = [];
        }
        /*if (params.hasOwnProperty('search_by_size') && params.search_by_size)
        {
          this.searchBySize();
        } else {
          this.getAll();
        }*/
        this.searchByVehicle = this.queryParams.searchByVehicle;
        this.activeDiameter = this.queryParams.rim_diameter;
        let storedData = localStorage.getItem('bodyImage');
        try {
          this.bodyImage = storedData ? JSON.parse(storedData) : null;
        } catch (error) {
          console.error('Error parsing bodyImage from localStorage:', error);
          this.bodyImage = null;
        }

        this.getAll();

        this.show_center_bore = localStorage.getItem("show_center_bore") != null ? true : false;
        this.show_wheel_weight = localStorage.getItem("show_wheel_weight") != null ? true : false;

      }
    });
    // console.log([this.queryParams]);
  }
  ngOnInit(): void {
    this.resolveProfilePage();
    this.checkIfLoggedIn();
    this.getFilters();

    this.dataService.diameter.asObservable().subscribe(diameter => {
      if (!diameter) {
        diameter = this.queryParams.rim_diameter;
      }
      this.activeDiameter = diameter;
      this.diameter = diameter;
    });


    var _params = this.queryParams;
    if(this.currentRoute == "/wheelbrand" && this.brand != undefined && !_params.hasOwnProperty('brand') && Object.keys(this.queryParams).length == 0){
      this.router.navigate(['/wheelbrand/', this.brand], { queryParams: { brand: this.brand } });
    }

    // this.currentRoute = window.location.pathname == '/wheels' ? '/wheels' : '/wheelbrand';
    // var _params = this.queryParams;
    // if(this.currentRoute == "/wheelbrand" && this.brand != undefined && !_params.hasOwnProperty('brand') && Object.keys(this.queryParams).length == 0){
    //   this.router.navigate(['/wheelbrand/', this.brand], { queryParams: { brand: this.brand } });
    // }
    this.resolveMetaTags();
  }

  ngOnDestroy(): void {
      if(this.profSub) {
        this.profSub.unsubscribe();
      }
  }

  checkIfLoggedIn() {
    const token = localStorage.getItem('ts_vendor_access_token');
    if(token) {
    } else {
      this.toastr.error("Please login first", 'Error');this.router.navigateByUrl('/');
      // this.router.navigate(['/']);
    }
  }

  resolveMetaTags(): void {
    let metaData: any = {
      title: this.route.snapshot.data.breadcrumbs.title,
      description: this.route.snapshot.data.breadcrumbs.description,
    };
    if (this.currentRoute == '/wheelbrand') {
      const search = /__BRAND__/gi;
      metaData.title = metaData.title.replace(search, this.brand);
      this.helperService.setPageTitle(metaData.title);
      metaData.description = metaData.description.replace(search, this.brand);
    }
    // console.log('metaData', metaData);
    this.helperService.setCustomMeta(metaData);
    if(this.currentRoute == "/wheelbrand" && this.brand != undefined ){
      this.metaService.updateCanonicalURLParam('brand='+this.brand);
    } else {
      this.metaService.updateCanonicalURL();
    }
  }

  setWarehouse(product_id:number, warehouse_id, is_eta:boolean) {
    this.warehouse_quantity['warehouse_id'] = warehouse_id;
    this.warehouse_quantity['quantity'] = 1;
    this.warehouse_quantity['is_eta'] = is_eta;
    this.warehouse_quantity['product'] = product_id;
  }

  getInventoryByProduct(product_id, product_variant_id){
    let inventory_loader = document.querySelector(".inventory_loader") as HTMLElement;
    let inventory_table = document.querySelector(".inventory_table") as HTMLElement;
    inventory_table.style.display = "none";
    inventory_loader.classList.remove("d-none");
    inventory_loader.classList.add("d-flex");

    this.inventoryData = [];
    this.apiService.getInventoryByProduct({product_id: product_id, variant_id: product_variant_id}).subscribe(
      response => {
        inventory_table.style.display = "block";
        inventory_loader.classList.remove("d-flex");
        inventory_loader.classList.add("d-none");
        this.clickedProductID = product_id;
        this.inventoryData = response.data;
      }
    );
  }


  searchBySize = () => {
    this.loadProducts = true;
    this.searchVehicleSub = this.apiService.getProductsByCustomSize(this.queryParams).subscribe(
      (response: Wheels) => {
        this.products = [...this.products, ...response.data.products.data];
        this.loadMoreProducts = false;
        this.loadProducts = false;
        //  this.filters = response.data.filters;
        if (response.data.products.next_page_url) {
          this.hasNextPage = true;
        } else {
          this.hasNextPage = false;
        }
      }, err => {
        this.loadMoreProducts = false;
      }
    );
  }

  getFilters = () => {
    this.apiService.getFilters(this.queryParams).subscribe(
      response => {
        this.filters = response.data.filters;
      }
    );
  }

  getAll = () => {
    const queryParams = Object.assign({}, this.queryParams);
    if(this.currentRoute == '/pre-order-deals'){ queryParams.clearance = true; }
    this.loadProducts = true;
    this.searchVehicleSub = this.apiService.getAllProducts(queryParams).subscribe(
      (response: Wheels) => {
        this.products = [...this.products, ...response.data.products.data];
        this.per_page = response.data.products.total;
        this.loadMoreProducts = false;
        this.loadProducts = false;
        this.products.forEach(product => {
          this.prodQty[product.product_variant_id] = 1; // set default value to 4
        });

        setTimeout(()=>{
          if (this.show_center_bore == true) {
            document.querySelectorAll(".hub_bore").forEach((hb)=>{
              hb.classList.remove("d-none");
            })
          }
  
          if (this.show_wheel_weight == true) {
            document.querySelectorAll(".wheel_weight").forEach((ww)=>{
              ww.classList.remove("d-none");
            })
          }
        }, 500)

        if (response.data.products.next_page_url) {
          this.hasNextPage = true;
        } else {
          this.hasNextPage = false;
        }
      }, err => {
        this.loadMoreProducts = false;
      }
    );
  }


  onFilterSelections = (params) => {
    this.products = [];
    // console.log("Filter select");

    if(this.currentRoute == '/pre-order-deals'){ params.clearance = true; }

    if (this.currentRoute == '/wheelbrand') {
      this.router.navigate([this.currentRoute, this.brand], {queryParams: params});
    } 
    else if(this.searchByVehicle ) {
      const existingParams = this.queryParams || {};
      const mergedParams = { ...existingParams, ...params };
      this.router.navigate([this.currentRoute], {queryParams: mergedParams});
    } 
    else {
      this.router.navigate([this.currentRoute], {queryParams: params});
    }
    // this.getAll();
  }

  onClear = (isClear) => {
    // console.log("sample2");
    this.products = [];
    if (isClear) {
      this.getAll();
    }
  }

  changePerPage = ($event) => {
    this.products = [];
    const params = Object.assign({}, this.queryParams);
    params.perPage = $event.target.value;

    if(this.currentRoute == '/pre-order-deals'){ params.clearance = true; }

    if (this.currentRoute == '/wheelbrand') {
      this.router.navigate([this.currentRoute, this.brand], {queryParams: params});
    } 
    else if(this.searchByVehicle ) {
      const existingParams = this.queryParams || {};
      const mergedParams = { ...existingParams, ...params };
      this.router.navigate([this.currentRoute], {queryParams: mergedParams});
    } 
    else {
      this.router.navigate([this.currentRoute], {queryParams: params});
    }
  }

  sortBy = (event) => {
    this.products = [];
    const params = Object.assign({}, this.queryParams);
    params.sortBy = event.target.value;

    if(this.currentRoute == '/pre-order-deals'){ params.clearance = true; }

    if (this.currentRoute == '/wheelbrand') {
      this.router.navigate([this.currentRoute, this.brand], {queryParams: params});
    } 
    else if(this.searchByVehicle ) {
      const existingParams = this.queryParams || {};
      const mergedParams = { ...existingParams, ...params };
      this.router.navigate([this.currentRoute], {queryParams: mergedParams});
    } 
    else {
      this.router.navigate([this.currentRoute], {queryParams: params});
    }
  }

  showOffers = (event) => {
    this.products = [];
    const params = Object.assign({}, this.queryParams);
    if(event.target['checked']){
        params.clearance = event.target['checked'];
    } else {
      delete params.clearance;
    }

    if(this.currentRoute == '/pre-order-deals'){ params.clearance = true; }

    if (this.currentRoute == '/wheelbrand') {
      this.router.navigate([this.currentRoute, this.brand], {queryParams: params});
    } 
    else if(this.searchByVehicle ) {
      const existingParams = this.queryParams || {};
      const mergedParams = { ...existingParams, ...params };
      this.router.navigate([this.currentRoute], {queryParams: mergedParams});
    } 
    else {
      this.router.navigate([this.currentRoute], {queryParams: params});
    }
  }

  downloadAsPDF() {
    this.show_center_bore = localStorage.getItem("show_center_bore") != null ? true : false;
    this.show_wheel_weight = localStorage.getItem("show_wheel_weight") != null ? true : false;
    const params = {...this.queryParams};
    if(this.show_wheel_weight) {
      params['show_weight'] = 1;
    }
    if(this.show_center_bore) {
      params['show_hubbore'] = 1;
    }
    delete params["per_page"];
    this.isDownloding = true;
    const downloadParams = this.searchByVehicle ? {...params, title: `Wheels For ${this.queryParams.year}  ${this.queryParams.make}  ${this.queryParams.model}`, img_url: this.bodyImage} : this.queryParams
    this.apiService.downloadSearchProducts(downloadParams).subscribe(response => {
      this.isDownloding = false;
      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'search-by-vehicle.pdf';
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }
  
  loadMore = () => {
    this.loadMoreProducts = true;
    setTimeout( () => {
      const params = Object.assign({}, this.queryParams);
      params.page = params.page ? ++params.page : 2;
      if (this.currentRoute == '/wheelbrand') {
        this.router.navigate([this.currentRoute, this.brand], {queryParams: params});
      } else {
        this.router.navigate([this.currentRoute], {queryParams: params});
      }
    }, 500);
  }

  onhideFilters(): void {
    this.showFilters = false;
  }



  addEditQty(warehouseCode, warehouseId, warehouseTotalQty, variantId, inventory, eta_qty=0, qty):void{

    let index = variantId+'_'+warehouseId;

    this.productCartTotalQty[variantId] = 0;
    this.prodQty[index] = qty;

    let inv = inventory;
    let totalQty = 0;
    let prodQty = this.prodQty;

    let allQtySum = eta_qty+warehouseTotalQty;

    if(qty > allQtySum){
      this.toastr.error("Invalid quantity. "+warehouseCode+" have only "+allQtySum+" quantity left.", 'Error');
    }
    else if(qty > 0) {
      inv.forEach( function(v,i) {
        if(typeof prodQty[variantId+'_'+v.warehouse.id] !== 'undefined'){
          totalQty += prodQty[variantId+'_'+v.warehouse.id] || 0;
        }
      } );
    }
    else if(qty < 0) {
      this.toastr.error("("+warehouseCode+") Invalid quantity.", 'Error');
    }

    this.productCartTotalQty[variantId] = totalQty;
  }


  onAddToCart(product): void {
    const prodId = product.product_id;
    const variantId = product.product_variant_id;
    const inventory = product.product_inventory;

    let inv = inventory;
    let prodQtys = this.prodQty;
    let error = true;
    let items:any = [];

    let item:any = {};

    let totalQty:number=0;

    item.product_id = prodId;
    item.product_variant_id = variantId;
    item.type = "";
    let product_eta = false;
    if (product.product_id === this.warehouse_quantity['product']) {
      product_eta = this.warehouse_quantity['is_eta'] == true ? true  : false;
      this.warehouse_quantity['quantity'] = product_eta ? this.prodQty[variantId] : 1;
      if (product_eta) {
        this.warehouse_quantity["eta"] = true;
      }
      delete this.warehouse_quantity['is_eta'];
      item.warehouse_qunatity = [this.warehouse_quantity]
    }
   
    // item.warehouse_qunatity = [];

    var _self = this;


    // inv.forEach(function(v,i){
      
    //   if(prodQtys[variantId+'_'+v.warehouse.id] > (v.quantity+v.eta_qty)){
    //     _self.toastr.error("Invalid quantity. "+v.warehouse.warehouse_name+" have only "+v.quantity+" quantity left.", 'Error');
    //   }
    //   else if(prodQtys[variantId+'_'+v.warehouse.id] <= 0 ){
    //     _self.toastr.error("("+v.warehouse.warehouse_name+") Invalid quantity.", 'Error');
    //   }
    //   else if(prodQtys[variantId+'_'+v.warehouse.id] > 0 ) {
    //     if(typeof prodQtys[variantId+'_'+v.warehouse.id] !== 'undefined'){
    //       error = false;
    //       totalQty += prodQtys[variantId+'_'+v.warehouse.id] || 0;
    //       warehouse_qunatity = {};
    //       warehouse_qunatity.warehouse_id = v.warehouse.id;
    //       warehouse_qunatity.quantity = prodQtys[variantId+'_'+v.warehouse.id];
    //       item.warehouse_qunatity.push(warehouse_qunatity);
    //     }

    //   }
      
    // });
    
    if (!product_eta) {
      if (this.getTotalQtyProduct(inv) == 0 && product.product_inventory[0].eta_qty > 0 && product.product_inventory[0].eta_qty <= prodQtys[variantId]){
        error = false;
      } else if (product.product_inventory[0].eta_qty >= prodQtys[variantId]){
        error = false;
      }else if(prodQtys[variantId] > this.getTotalQtyProduct(inv)){
        _self.toastr.error("Invalid quantity. only "+this.getTotalQtyProduct(inv)+" quantity left.", 'Error');
      }
      else if(prodQtys[variantId] <= 0){
        _self.toastr.error("Invalid quantity.", 'Error');
      }
      else if(prodQtys[variantId] > 0) {
        error = false;
      }
    } else if(product_eta) {
      const targetInventory = product.product_inventory.find(inventory => inventory.warehouse_id === item.warehouse_qunatity[0].warehouse_id);
      if (this.getTotalQtyProduct(inv) == 0 && product.product_inventory[0].eta_qty > 0){
        error = false;
      }
      else if (prodQtys[variantId] > targetInventory.eta_qty) {
        _self.toastr.error("Invalid quantity. only "+targetInventory.eta_qty+" quantity left.", 'Error');
      } else if (prodQtys[variantId] <= 0) {
        _self.toastr.error("Invalid quantity.", 'Error');
      }else if(prodQtys[variantId] > 0) {
        error = false;
      }
    }



    item.quantity = this.prodQty[variantId];
    items.push(item);

    /*if(totalQty < 4){
      error = true;
      this.toastr.error("Minimum purchase quantity should be 4", 'Error');
    }*/

    if(!error){


      this.productCartTotalQty[variantId] = this.prodQty[variantId];
      this.cartItems = items;
      this.addToCart(product);

    } else {
      this.productCartTotalQty[variantId] = 0;
    }
  }


  notifyAddToCart(product):void {
    const prodId = product.product_id;
    const variantId = product.product_variant_id;
    const inventory = product.product_inventory;

    this.apiService.notifyAddToCart(variantId).subscribe(
      response => {
        if(response.status){
          this.toastr.success('Alert set!', 'Success');
        }
      },
      error => {}
    );

  }

  addToCart(product): void {
    this.prodAddons = [];
    // tslint:disable-next-line:variable-name
    const session_id = localStorage.getItem('session_id');
    const data = {
      session_id,
      items: this.cartItems,
    };

    this.cartProcessing = true;
    this.cartSubscription = this.apiService.addToCart(data).subscribe(
      response => {
        this.cartProcessing = false;
        if (response.status) {
          this.productAddedToCart = product;

          let totalItem =  this.cartItems.length;

          this.cartResp = response.data;
          const productcustomization = this.cartResp.product_customizations[this.getFirstKey(this.cartResp.product_customizations)];
          if(productcustomization.is_offset_drilling){
            this.generateOffsetDropdownValues(this.productAddedToCart.offset);
          }
          if(productcustomization.bolt_patterns && productcustomization.bolt_patterns.length>0){
            productcustomization.bolt_patterns.sort((a, b) => {
              // Extracting the numerical part of the bolt strings
              const numA = parseFloat(a.split("x")[1]);
              const numB = parseFloat(b.split("x")[1]);
          
              // Comparing the numerical parts
              return numA - numB;
          });
          }

          const isCustomFinish = this.cartResp.product_customizations[this.getFirstKey(this.cartResp.product_customizations)].is_custom_finish;
          const isBoltPatterns = this.cartResp.product_customizations[this.getFirstKey(this.cartResp.product_customizations)].bolt_patterns;

          if(isCustomFinish && isBoltPatterns && isBoltPatterns.length){
              this.isProductCustomization = true;
          }else{
              this.isProductCustomization = false;
          }
          this.pc_cost_per_wheel = productcustomization.pc_cost_per_wheel ? productcustomization.pc_cost_per_wheel : '';

          this.apiService.getCart().subscribe(response => {
              if (response.status) {
                this.dataService.setCartData(response);
              }
          });

          this.apiService.getAddsOnByProduct(this.cartItems[0].product_id).subscribe(
            response => {
              if(response.status){
                this.prodAddons = response.data;
              }
            },
            error => {}
          );

          let element:HTMLElement = document.getElementById('auto_trigger') as HTMLElement;
          element.click();
          document.querySelector(".cartpopupmessage").classList.remove("d-none");
          setTimeout(()=>{
            // document.querySelector(".nav-tabs").getElementsByTagName("a")[0].click();
            document.querySelector(".cartpopupmessage").classList.add("d-none");
          }, 2000)
          //this.successMessage = response.message;
          this.toastr.success(response.message, 'Success');
          
        }
      }, error => {
        this.cartProcessing = false;
        this.toastr.error(error.error.message, 'Error');
      }
    );

  }

  getFirstKey(object:any){
    try {
      return (Object.keys(object)[0]);
    } catch{
      return '';
    }
  }

  closeModalAndRedirectCart = (isRedirectNeeded = false) => {
    this.addToCartFromProductCustomizationPopup(this.productAddedToCart);
    this.modalService.dismissAll();
    if (isRedirectNeeded) {
      this.router.navigateByUrl('/cart');
    }
  }


  openModal(content):void {
    this.addToCartPopup = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', centered: true,windowClass: 'wheel-modal'});

    this.addToCartPopup.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  productQtyCheck = (inventory) => {
    let totalQty = 0;
    inventory.forEach(function (inv) {
      // console.log(inv.eta_qty);
      // console.log(inv.quantity);
      totalQty += inv.eta_qty + inv.quantity;
    }); 
    // console.log(totalQty);
    return totalQty;
  }

  generateOffsetDropdownValues(offset):void {
    this.offsetDropdownValues = [];
    // Parse offset value
    // const parts = offset.split(/\/|to|-/);
    const parts = offset.split(/\s*to\s*/);
    if (parts.length === 1) {
      // If only one value, assume it's a single offset
      this.offsetDropdownValues = [];
    } else if (parts.length === 2) {
      // If two values, assume it's a range
      const start = parseFloat(parts[0]);
      const end = parseFloat(parts[1]);
      if (!isNaN(start) && !isNaN(end)) {
        for (let i = start; i <= end; i++) {
          this.offsetDropdownValues.push(i);
        }
      }
    }
    this.offsetDropdownValues.sort((a, b) => a - b);
  }

  onCustomFinishSelect(event){
    const custom_finish = this.cartResp.product_customizations[this.getFirstKey(this.cartResp.product_customizations)].product_customizations.find(x => x.id == event.target.value);
    if(custom_finish){
      this.custom_finish_price = custom_finish.cost;
    }
  }

  addToCartFromProductCustomizationPopup(product): void {
    this.p_customization_submitted = true;
    if(this.offsetDropdownValues.length == 0){
      this.offset = '';
    }
    if((this.cartResp?.product_customizations && this.cartResp?.product_customizations[this.getFirstKey(this.cartResp?.product_customizations)]?.bolt_patterns && (this.cartResp?.product_customizations && this.cartResp.product_customizations[this.getFirstKey(this.cartResp?.product_customizations)]?.bolt_patterns?.length == 0)) || (!!this.cartResp?.product_customizations &&  !this.cartResp?.product_customizations[this.getFirstKey(this.cartResp.product_customizations)]?.bolt_patterns)){
      this.bolt_pattern = '';
    }
    if((this.bolt_pattern == 'recommended' || this.offset == 'recommended') && !this.vehicle_year_make_model){
      return;
    }
    if (this.cartResp?.product_customizations) {
      if((this.cartResp.product_customizations[this.getFirstKey(this.cartResp.product_cusstomizations)]?.is_custom_finish) || (this.cartResp?.product_customizations && this.cartResp.product_customizations[this.getFirstKey(this.cartResp.product_customizations)]?.bolt_patterns)){
        const session_id = localStorage.getItem('session_id');
        const product_id = product.product_id;
        const product_variant_id = product.product_variant_id;
        const data = {
          session_id,
          product_id,
          product_variant_id,
          type: "pc_updated_to_cart_directly",
          custom_finish: this.custom_finish,
          custom_finish_price: this.custom_finish_price,
          bolt_pattern: this.bolt_pattern,
          offset: this.offset,
          cost_per_wheel: this.pc_cost_per_wheel,
          vehicle_year_make_model : this.vehicle_year_make_model
        };
        this.cartProcessing = true;
        this.cartSubscription = this.apiService.addToCart(data).subscribe(
          response => {
              this.cartProcessing = false;
              if (response.status) {
                
                // this.cartResp = response.data;
    
                this.apiService.getCart().subscribe(response => {
                  if (response.status) {
                    this.dataService.setCartData(response);
                  }
              });
    
              this.isProductCustomization = false;
              if (this.addToCartPopup) {
                this.addToCartPopup.close();
              }
              this.apiService.getAddsOnByProduct(this.cartItems[0].product_id).subscribe(
                response => {
                  if(response.status){
                    this.prodAddons = response.data;
                  }
                },
                error => {}
              );
              this.resetProdCustomizationProperties();
              let element:HTMLElement = document.getElementById('auto_trigger') as HTMLElement;
              element.click();
              this.toastr.success(response.message, 'Success');
            }
          }, error => {
            this.cartProcessing = false;
            this.toastr.error(error.error.message, 'Error');
          }
        );
      } else {
        const session_id = localStorage.getItem('session_id');
        const product_id = product.product_id;
        const product_variant_id = product.product_variant_id;
        const data = {
          session_id,
          product_id,
          product_variant_id,
          type: "pc_updated_to_cart_directly",
          custom_finish: '',
          custom_finish_price: '',
          bolt_pattern: '',
          offset: '',
          cost_per_wheel: '',
          vehicle_year_make_model : this.vehicle_year_make_model
        };
        this.cartProcessing = true;
        this.cartSubscription = this.apiService.addToCart(data).subscribe(
          response => {
              this.cartProcessing = false;
              if (response.status) {
                
                // this.cartResp = response.data;
    
              this.isProductCustomization = false;
              
              
              this.resetProdCustomizationProperties();
              
            }
          }, error => {
            this.cartProcessing = false;
            this.toastr.error(error.error.message, 'Error');
          }
        );
      }
    }
  }

  resetProdCustomizationProperties(){
    this.custom_finish = '';
    this.custom_finish_price = '';
    this.bolt_pattern = 'recommended';
    this.offset = 'recommended';
    this.pc_cost_per_wheel = '';
    this.vehicle_year_make_model = '';
    this.p_customization_submitted = false;
  }


  quantity: number = 1;
  minQuantity: number = 1;

  // incrementQuantity() {
  //   this.quantity++;
  // }

  // decrementQuantity() {
  //   if (this.quantity > this.minQuantity) {
  //     this.quantity--;
  //   }
  // }


  getTotalQtyProduct(inv){
    let totalQty = 0;
    inv.forEach( function(v,i) {
      totalQty += v.quantity;
    });

    return totalQty;
  }


   incrementQuantity(product_variant_id, in_stock_qty, eta_qty) {
    if(this.prodQty[product_variant_id] < (in_stock_qty+eta_qty)){
      this.prodQty[product_variant_id]++;
    }
    
  }

  decrementQuantity(product_variant_id, in_stock_qty, eta_qty) {
    if (this.prodQty[product_variant_id] > this.minQuantity) {
      this.prodQty[product_variant_id]--;
    }
  }


  getWheelsByDiameter = (diameter: number) => {
    this.products = [];
    const params = Object.assign({}, this.queryParams);
    params.rim_diameter = diameter;
    // this.activeDiameter = diameter;

    this.getFilters();
    this.router.navigate(['/wheels'], {queryParams: params});

    // if(this.serchvehiclehome){
    //   // this.router.navigate(['/serchvehiclehome'], {queryParams: params});
    //   this.router.navigate(['/search-by-size'], {queryParams: params});
    // } else {
    //   this.getFilters();
    //   this.router.navigate(['/wheels'], {queryParams: params});
    // }
    // this.router.navigate(['/serchvehicle'], {queryParams: params});
  }

  toggleIcon() {
    this.showFirstIcon = !this.showFirstIcon;
  }



}



